import _export from '../internals/export.js';
import anObject$1 from '../internals/an-object.js';
import '../internals/object-get-own-property-descriptor.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var anObject = anObject$1;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f; // `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty

$({
  target: 'Reflect',
  stat: true
}, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});
